export const GeneralTranslation = {
  ru: {
    search: "Поиск",
    name: "Название",
    discard: "Отменить",
    save: "Сохранить",
    cancel: "Отменить",
    confirm: "Подтвердить",
    category: "Категория",
    subcategory: "Подкатегория",
    step: "Шаг",
    package: "пакет",
    license: "лицензия",
    details: "Детали",
    required: "обязательно",
    invalidZipFile: "Пожалуйста, загрузите корректный ZIP файл.",
    uploadFailed: "Не удалось загрузить ZIP файл.",
    uploadSuccess: "ZIP файл успешно загружен.",
    uploadBeforeSave: "Пожалуйста, загрузите ZIP файл перед сохранением.",
    addPackage: "Добавить пакет",
    uploadZipFile: "Загрузить ZIP файл",
    dragDropOrClick: "Перетащите ZIP файл сюда или нажмите для выбора",
    addIndividually: "+ Добавить по отдельности",
    deleteSuccess: "Пакет успешно удален.",
    deleteFailed: "Не удалось удалить пакет.",
  },
  cz: {
    search: "Hledat",
    name: "Název",
    discard: "Zahodit",
    save: "Uložit",
    cancel: "Zrušit",
    confirm: "Potvrdit",
    category: "Kategorie",
    subcategory: "Podkategorie",
    step: "Kroky",
    package: "balíček",
    license: "licence",
    details: "Detaily",
    required: "povinné",
    invalidZipFile: "Prosím nahrajte platný ZIP soubor.",
    uploadFailed: "Nahrávání ZIP souboru se nezdařilo.",
    uploadSuccess: "ZIP soubor byl úspěšně nahrán.",
    uploadBeforeSave: "Prosím nahrajte ZIP soubor před uložením.",
    addPackage: "Přidat balíček",
    uploadZipFile: "Nahrát ZIP soubor",
    dragDropOrClick: "Přetáhněte ZIP soubor sem, nebo klikněte pro výběr",
    addIndividually: "+ Přidat jednotlivě",
    deleteSuccess: "Balíček byl úspěšně smazán.",
    deleteFailed: "Nepodařilo se smazat balíček.",
  },
  en: {
    search: "Search",
    name: "Name",
    discard: "Discard",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    category: "Category",
    subcategory: "Subcategory",
    step: "Step",
    package: "package",
    license: "license",
    details: "Details",
    required: "required",
    invalidZipFile: "Please upload a valid ZIP file.",
    uploadFailed: "Failed to upload ZIP file.",
    uploadSuccess: "ZIP file uploaded successfully.",
    uploadBeforeSave: "Please upload a ZIP file before saving.",
    addPackage: "Add package",
    uploadZipFile: "Upload ZIP File",
    dragDropOrClick: "Drag & drop a ZIP file here, or click to select one",
    addIndividually: "+ Add individually",
    deleteSuccess: "Package deleted successfully.",
    deleteFailed: "Failed to delete package.",
  },
  de: {
    search: "Suchen",
    name: "Name",
    discard: "Verwerfen",
    save: "Speichern",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    category: "Kategorie",
    subcategory: "Unterkategorie",
    step: "Schritt",
    package: "Paket",
    license: "Lizenz",
    details: "Einzelheiten",
    required: "obligatorisch",
    invalidZipFile: "Bitte laden Sie eine gültige ZIP-Datei hoch.",
    uploadFailed: "Fehler beim Hochladen der ZIP-Datei.",
    uploadSuccess: "ZIP-Datei erfolgreich hochgeladen.",
    uploadBeforeSave:
      "Bitte laden Sie eine ZIP-Datei hoch, bevor Sie speichern.",
    addPackage: "Paket hinzufügen",
    uploadZipFile: "ZIP-Datei hochladen",
    dragDropOrClick:
      "Ziehen Sie eine ZIP-Datei hierher oder klicken Sie, um eine auszuwählen",
    addIndividually: "+ Einzeln hinzufügen",
    deleteSuccess: "Paket erfolgreich gelöscht.",
    deleteFailed: "Löschen des Pakets fehlgeschlagen.",
  },
  es: {
    search: "Buscar",
    name: "Nombre",
    discard: "Descartar",
    save: "Guardar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    category: "Categoría",
    subcategory: "Subcategoría",
    step: "Paso",
    package: "paquete",
    license: "licencia",
    details: "Detalles",
    required: "obligatorio",
    invalidZipFile: "Por favor, suba un archivo ZIP válido.",
    uploadFailed: "Error al subir el archivo ZIP.",
    uploadSuccess: "Archivo ZIP subido con éxito.",
    uploadBeforeSave: "Por favor, suba un archivo ZIP antes de guardar.",
    addPackage: "Agregar paquete",
    uploadZipFile: "Subir archivo ZIP",
    dragDropOrClick:
      "Arrastra y suelta un archivo ZIP aquí, o haz clic para seleccionar uno",
    addIndividually: "+ Agregar individualmente",
    deleteSuccess: "Paquete eliminado con éxito.",
    deleteFailed: "Error al eliminar el paquete.",
  },
  fr: {
    search: "Rechercher",
    name: "Nom",
    discard: "Jeter",
    save: "Enregistrer",
    cancel: "Annuler",
    confirm: "Confirmer",
    category: "Catégorie",
    subcategory: "Sous-catégorie",
    step: "Étape",
    package: "paquet",
    license: "Licence",
    details: "Détails",
    required: "obligatoire",
    invalidZipFile: "Veuillez télécharger un fichier ZIP valide.",
    uploadFailed: "Échec du téléchargement du fichier ZIP.",
    uploadSuccess: "Fichier ZIP téléchargé avec succès.",
    uploadBeforeSave:
      "Veuillez télécharger un fichier ZIP avant de sauvegarder.",
    addPackage: "Ajouter un paquet",
    uploadZipFile: "Télécharger le fichier ZIP",
    dragDropOrClick:
      "Glissez-déposez un fichier ZIP ici, ou cliquez pour en sélectionner un",
    addIndividually: "+ Ajouter individuellement",
    deleteSuccess: "Paquet supprimé avec succès.",
    deleteFailed: "Échec de la suppression du paquet.",
  },
  hu: {
    search: "Keresés",
    name: "Név",
    discard: "Elvet",
    save: "Mentés",
    cancel: "Mégse",
    confirm: "Megerősít",
    category: "Kategória",
    subcategory: "Alkategória",
    step: "Lépés",
    package: "csomag",
    license: "engedély",
    details: "Részletek",
    required: "kötelező",
    invalidZipFile: "Kérjük, töltsön fel egy érvényes ZIP fájlt.",
    uploadFailed: "A ZIP fájl feltöltése nem sikerült.",
    uploadSuccess: "A ZIP fájl sikeresen feltöltve.",
    uploadBeforeSave: "Kérjük, töltsön fel egy ZIP fájlt a mentés előtt.",
    addPackage: "Csomag hozzáadása",
    uploadZipFile: "ZIP fájl feltöltése",
    dragDropOrClick: "Húzza ide a ZIP fájlt, vagy kattintson a kiválasztáshoz",
    addIndividually: "+ Egyenként hozzáadni",
    deleteSuccess: "Csomag sikeresen törölve.",
    deleteFailed: "Nem sikerült törölni a csomagot.",
  },
  nl: {
    search: "Zoeken",
    name: "Naam",
    discard: "Verwijderen",
    save: "Opslaan",
    cancel: "Annuleren",
    confirm: "Bevestigen",
    category: "Categorie",
    subcategory: "Subcategorie",
    step: "Stap",
    package: "pakket",
    license: "licentie",
    details: "Details",
    required: "verplicht",
    invalidZipFile: "Upload een geldig ZIP-bestand.",
    uploadFailed: "Het uploaden van het ZIP-bestand is mislukt.",
    uploadSuccess: "ZIP-bestand succesvol geüpload.",
    uploadBeforeSave: "Upload een ZIP-bestand voordat u opslaat.",
    addPackage: "Pakket toevoegen",
    uploadZipFile: "ZIP-bestand uploaden",
    dragDropOrClick:
      "Sleep een ZIP-bestand hierheen of klik om er een te selecteren",
    addIndividually: "+ Individueel toevoegen",
    deleteSuccess: "Pakket succesvol verwijderd.",
    deleteFailed: "Verwijderen van pakket mislukt.",
  },
  pl: {
    search: "Szukaj",
    name: "Nazwa",
    discard: "Odrzuć",
    save: "Zapisz",
    cancel: "Anuluj",
    confirm: "Potwierdź",
    category: "Kategoria",
    subcategory: "Podkategoria",
    step: "Krok",
    package: "pakiet",
    license: "licencja",
    details: "Szczegóły",
    required: "obowiązkowy",
    invalidZipFile: "Proszę przesłać prawidłowy plik ZIP.",
    uploadFailed: "Nie udało się przesłać pliku ZIP.",
    uploadSuccess: "Plik ZIP został pomyślnie przesłany.",
    uploadBeforeSave: "Prześlij plik ZIP przed zapisaniem.",
    addPackage: "Dodaj pakiet",
    uploadZipFile: "Prześlij plik ZIP",
    dragDropOrClick:
      "Przeciągnij i upuść plik ZIP tutaj lub kliknij, aby go wybrać",
    addIndividually: "+ Dodaj indywidualnie",
    deleteSuccess: "Pakiet został pomyślnie usunięty.",
    deleteFailed: "Nie udało się usunąć pakietu.",
  },
  sk: {
    search: "Hľadať",
    name: "Názov",
    discard: "Zahodiť",
    save: "Uložiť",
    cancel: "Zrušiť",
    confirm: "Potvrdiť",
    category: "Kategória",
    subcategory: "Podkategória",
    step: "Kroky",
    package: "balík",
    license: "licencia",
    details: "Detaily",
    required: "povinné",
    invalidZipFile: "Prosím nahrajte platný ZIP súbor.",
    uploadFailed: "Nahrávanie ZIP súboru sa nepodarilo.",
    uploadSuccess: "ZIP súbor bol úspešne nahraný.",
    uploadBeforeSave: "Prosím nahrajte ZIP súbor pred uložením.",
    addPackage: "Pridať balík",
    uploadZipFile: "Nahrať ZIP súbor",
    dragDropOrClick: "Pretiahnite ZIP súbor sem, alebo kliknite pre výber",
    addIndividually: "+ Pridať jednotlivo",
    deleteSuccess: "Balík bol úspešne vymazaný.",
    deleteFailed: "Nepodarilo sa vymazať balík.",
  },
  sv: {
    search: "Sök",
    name: "Namn",
    discard: "Kassera",
    save: "Spara",
    cancel: "Avbryt",
    confirm: "Bekräfta",
    category: "Kategori",
    subcategory: "Underkategori",
    step: "Steg",
    package: "paket",
    license: "licens",
    details: "Detaljer",
    required: "obligatoriskt",
    invalidZipFile: "Vänligen ladda upp en giltig ZIP-fil.",
    uploadFailed: "Det gick inte att ladda upp ZIP-filen.",
    uploadSuccess: "ZIP-filen laddades upp framgångsrikt.",
    uploadBeforeSave: "Ladda upp en ZIP-fil innan du sparar.",
    addPackage: "Lägg till paket",
    uploadZipFile: "Ladda upp ZIP-fil",
    dragDropOrClick: "Dra och släpp en ZIP-fil här, eller klicka för att välja",
    addIndividually: "+ Lägg till individuellt",
    deleteSuccess: "Paket raderat framgångsrikt.",
    deleteFailed: "Det gick inte att radera paketet.",
  },
  no: {
    search: "Søk",
    name: "Navn",
    discard: "Forkast",
    save: "Lagre",
    cancel: "Avbryt",
    confirm: "Bekreft",
    category: "Kategori",
    subcategory: "Underkategori",
    step: "Steg",
    package: "pakke",
    license: "lisens",
    details: "Detaljer",
    required: "påkrevd",
    invalidZipFile: "Vennligst last opp en gyldig ZIP-fil.",
    uploadFailed: "Kunne ikke laste opp ZIP-filen.",
    uploadSuccess: "ZIP-filen ble lastet opp.",
    uploadBeforeSave: "Vennligst last opp en ZIP-fil før du lagrer.",
    addPackage: "Legg til pakke",
    uploadZipFile: "Last opp ZIP-fil",
    dragDropOrClick: "Dra og slipp en ZIP-fil her, eller klikk for å velge en",
    addIndividually: "+ Legg til individuelt",
    deleteSuccess: "Pakke slettet.",
    deleteFailed: "Kunne ikke slette pakken.",
  },
  da: {
    search: "Søg",
    name: "Navn",
    discard: "Kassér",
    save: "Gem",
    cancel: "Annuller",
    confirm: "Bekræft",
    category: "Kategori",
    subcategory: "Underkategori",
    step: "Skridt",
    package: "pakke",
    license: "licens",
    details: "Detaljer",
    required: "påkrævet",
    invalidZipFile: "Upload en gyldig ZIP-fil.",
    uploadFailed: "Kunne ikke uploade ZIP-filen.",
    uploadSuccess: "ZIP-filen blev uploadet.",
    uploadBeforeSave: "Upload en ZIP-fil, før du gemmer.",
    addPackage: "Tilføj pakke",
    uploadZipFile: "Upload ZIP-fil",
    dragDropOrClick: "Træk og slip en ZIP-fil her, eller klik for at vælge en",
    addIndividually: "+ Tilføj individuelt",
    deleteSuccess: "Pakke slettet.",
    deleteFailed: "Kunne ikke slette pakken.",
  },
  fi: {
    search: "Hae",
    name: "Nimi",
    discard: "Hylkää",
    save: "Tallenna",
    cancel: "Peruuta",
    confirm: "Vahvista",
    category: "Kategoria",
    subcategory: "Alakategoria",
    step: "Vaihe",
    package: "paketti",
    license: "lisenssi",
    details: "Tiedot",
    required: "vaadittu",
    invalidZipFile: "Lataa kelvollinen ZIP-tiedosto.",
    uploadFailed: "ZIP-tiedoston lataaminen epäonnistui.",
    uploadSuccess: "ZIP-tiedosto ladattu onnistuneesti.",
    uploadBeforeSave: "Lataa ZIP-tiedosto ennen tallentamista.",
    addPackage: "Lisää paketti",
    uploadZipFile: "Lataa ZIP-tiedosto",
    dragDropOrClick:
      "Vedä ja pudota ZIP-tiedosto tähän tai valitse napsauttamalla",
    addIndividually: "+ Lisää yksitellen",
    deleteSuccess: "Paketti poistettu onnistuneesti.",
    deleteFailed: "Pakettia ei voitu poistaa.",
  },
  ar: {
    search: "بحث",
    name: "الاسم",
    discard: "تجاهل",
    save: "حفظ",
    cancel: "إلغاء",
    confirm: "تأكيد",
    category: "الفئة",
    subcategory: "الفئة الفرعية",
    step: "خطوة",
    package: "الحزمة",
    license: "الرخصة",
    details: "التفاصيل",
    required: "مطلوب",
    invalidZipFile: "يرجى تحميل ملف ZIP صالح.",
    uploadFailed: "فشل تحميل ملف ZIP.",
    uploadSuccess: "تم تحميل ملف ZIP بنجاح.",
    uploadBeforeSave: "يرجى تحميل ملف ZIP قبل الحفظ.",
    addPackage: "إضافة حزمة",
    uploadZipFile: "تحميل ملف ZIP",
    dragDropOrClick: "اسحب وأفلت ملف ZIP هنا، أو انقر لاختياره",
    addIndividually: "+ إضافة بشكل فردي",
    deleteSuccess: "تم حذف الحزمة بنجاح.",
    deleteFailed: "فشل في حذف الحزمة.",
  },
};

export default GeneralTranslation;
